import { Injectable,Inject } from '@angular/core';
import { HttpClient,HttpHeaders, HttpRequest } from '@angular/common/http';
import jsSHA from 'jssha';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { DOCUMENT } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class PokemonService {
  baseUrl =  'https://api3.wickedcampers.com/v3';
  imageUrl = 'https://api3.wickedcampers.com/v3';
  
  AUBookapiurl='https://api.wickedcampers.com.au';
  RCMbookingurl="https://apis.rentalcarmanager.com/booking/v3.2/";
  NZBookapiurl='https://api2.wickedcampers.co.nz';


  constructor(@Inject(DOCUMENT) private dom,private http: HttpClient) {}
 
  getCountry() {
    return this.http
      .get(`${this.baseUrl}/country`)
      .pipe(
        map(result => {
          return result['results'];
        }),
      
      );
  }
  getVehicle(featured=0,country='') {
    let filter="";
    if(country!='') filter=`&country=${country}`;
    return this.http
      .get(`${this.baseUrl}/vehicles?featured=${featured}${filter}`)
      .pipe(
        map(result => {
          return result;
        }),
      
      );
  }
  getVehicleDetails(country,index) {
    let filter="";
    if(country!='') filter=`&country=${country}`;
    return this.http
      .get(`${this.baseUrl}/vehicles/detail/${country}/${index}`)
      .pipe(
        map(result => {
          return result;
        }),
      
      );
  }

  getLocation(featured=0,country="") {
    let filter="";
    if(country!='') filter=`&country=${country}`;
    return this.http
      .get(`${this.baseUrl}/location?featured=${featured}${filter}`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  getLocationDetails(country,index) {
    return this.http.get(`${this.baseUrl}/location/detail/${country}/${index}`)
	 .pipe(
      map(poke => {
        /*
        let slides = Object.keys(poke['slides']);
        poke['images'] = slides
          .map(spriteKey => poke['slides'][spriteKey]['url'])
          .filter(img => img);
        */
        return poke;
      })
    );
  }

  
  gettripideas(offset = 0) {
    return this.http
    .get(`${this.baseUrl}/trip/list/?offset=${offset}&limit=0`)
      .pipe(
        map(result => {
          return result['results'];
        }),
      );
  }

  
   getSlider(offset = 0){
	  return this.http
      .get(`${this.baseUrl}/homeslide/?offset=${offset}&limit=0`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
	  
  }
  
  getMenu(){
	  return this.http
      .get(`${this.baseUrl}/menu/`)
      .pipe(
        map(result => {
          return result['menu'];
        }),
        
      );
	  
  }

  
  getPromo(country=''){
    let filter='';
    if(country!=''){
      filter=`?country=${country}`;
    }
	  return this.http
      .get(`${this.baseUrl}/promo${filter}`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
	  
  }
  
    getAVailloc(index) {
    return this.http.get(`${this.baseUrl}/vehicles/detail/${index}`)
	 .pipe(
      map(poke => {
		let loc = Object.keys(poke['available_locations']);
        poke['loci'] =loc.map(spriteKey => poke['available_locations'][spriteKey]);
        return poke;
      })
    );
  }
  
	getAVaillocDetails(index) {
    return this.http.get(`${this.baseUrl}/location/detail/${index}`)
	 .pipe(
      map(poke => {
		//let loc = Object.keys(poke['address']);
        //poke['loci'] =loc.map(spriteKey => poke['address'][spriteKey]);
        return poke;
      })
    );
  }
  
  getAVailDetails(index) {
    return this.http.get(`${this.baseUrl}/vehicles/detail/${index}`)
	 .pipe(
      map(poke => {
		let loc = Object.keys(poke['specification']);
        poke['locic'] =loc.map(spriteKey => poke['specification'][spriteKey]);
        return poke;
      })
    );
  }


  getKomen(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/review`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getTripDetails(index) {
    return this.http.get(`${this.baseUrl}/trip/detail/${index}`)
	 .pipe(
      map(poke => {
		let slides = Object.keys(poke['slides']);
        poke['images'] = slides
          .map(spriteKey => poke['slides'][spriteKey]['url'])
          .filter(img => img);
        return poke;
      })
    );
  }
  getMenugroup(){
    return this.http.get(`${this.baseUrl}/menu/group/footer`)
    .pipe(
      map(result => {
        return result['results'];
      }),
    );
  }
  
  getPagesDetail(index) {
    return this.http.get(`${this.baseUrl}/staticpage/detail/${index}`)
	 .pipe(
      map(poke => {
    /*
        let slides = Object.keys(poke['slides']);
        poke['images'] = slides
          .map(spriteKey => poke['slides'][spriteKey]['url'])
          .filter(img => img);
         */ 
        return poke;
      })
    );
  }
  getSpecials(country='') {
    let query='';
    if(country!='') query=`?country=${country}`
    return this.http
      .get(`${this.baseUrl}/special${query}`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsau(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=au`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsnz(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=nz`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsca(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=ca`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsuk(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=uk`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialssa(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=sa`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsaf(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/special/list?country=af`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getSpecialsDetail(index) {
    return this.http.get(`${this.baseUrl}/special/detail/${index}`)
	 .pipe(
      map(poke => {
   
        return poke;
      })
    );
  }
  getBlog(offset = 0) {
    return this.http
      .get(`${this.baseUrl}/blog/list/?offset=${offset}&limit=0`)
      .pipe(
        map(result => {
          return result['results'];
        }),
        
      );
  }
  getBlogDetails(index) {
    return this.http.get(`${this.baseUrl}/blog/detail/${index}`)
	 .pipe(
      map(poke => {
   
        return poke;
      })
    );
  }


  //bookings 
  bookingGetVehDetail(rcmid) {
    return this.http
      .get(`${this.AUBookapiurl}/v3/bookings/getvehicledata/${rcmid}`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  bookingGetVehDetailnz(rcmid) {
    return this.http
      .get(`${this.NZBookapiurl}/v3/bookings/getvehicledata/${rcmid}`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  bookingGetSlider(rcmid) {
    return this.http
      .get(`${this.AUBookapiurl}/v3/bookings/getslider/${rcmid}`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  bookingGetSlidernz(rcmid) {
    return this.http
      .get(`${this.NZBookapiurl}/v3/bookings/getslider/${rcmid}`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  bookingGetvcat() {
    return this.http
      .get(`${this.AUBookapiurl}/v3/bookings/getcatlist`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  bookingGetvcatnz() {
    return this.http
      .get(`${this.NZBookapiurl}/v3/bookings/getcatlist`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }

  rcmgetkey(country="au"){
    let key={
      key:"QXVXaWNrZWRDYW1wZXJzW3VuZGVmaW5lZF18YnVkaUB3aWNrZWRjYW1wZXJzLmNvbS5hdXxkT2Q5eE41bw==",
      secret:"P3BJiKohGrql2bAmDlj8Jy0K1OMiLGqG"
    };
    if(country=="nz"){
      key.key="QXVXaWNrZWROWlt1bmRlZmluZWRdfGJ1ZGlAd2lja2VkY2FtcGVycy5jb20uYXV8Qm9wOWw5NEk=";
      key.secret="0qoHpArN9fMykjh8t0l1mzK2bI5l2dAo"
    } else if(country=="uk"){
      key.key="VUtXaWNrZWQxMDB8YnVkaUB3aWNrZWRjYW1wZXJzLmNvbS5hdXwyNXBtcXhLRw==";
      key.secret="olH91MN90xIriAN0yEJBi4PC4D3ev38z";
    } else if(country=="ca"){
      key.key="R3U1V0dIM1BEQ1g3ZlBoRW1oTXROR1pMTldCY0M3";
      key.secret="K*jEg27r2Xf4Zh3MbYBa=Kfrgm7DMe";
    } else if(country=="af"){
      key.key="WkFXaWNrZWQ4MHxidWRpQHdpY2tlZGNhbXBlcnMuY29tLmF1fG1qRW9pTXFF";
      key.secret="mIec670iDvnj6e1oiGi5s0aJDoKjfmkK";
    } else if(country=="jp"){
      key.key="SlBXaWNrZWQ3MHxidWRpQHdpY2tlZGNhbXBlcnMuY29tLmF1fHpHcFB0aEhF";
      key.secret="mklML4zka6kOviOtLGeeO57KKJ4zyj25";
    } 
    return key;
  }
  getRCMLocation(country="au"){
    let key=this.rcmgetkey(country);
    let signature:any;
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update('{"method":"step1"}');
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request={"method":"step1"}';
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
        
    );
  }
  getRCMConfirmpaymentau(payres,country="au"){

    let key=this.rcmgetkey("au");
    if(country=="nz"){
      key=this.rcmgetkey("nz");
    }
    let signature:any;
    let txt1=payres['cardexpiry'];
    let txt2 = txt1.slice(0, 2) + "/" + txt1.slice(2);
    
    //console.log(optmethod);
    let method='{"method":"confirmpayment","reservationref":"'+payres['reservationref']+'","amount":'+payres['amount']+',"success":true,"paytype":"'+payres['paytype']+'","paydate":"'+payres['paydate']+'","supplierid":2,"transactid":"'+payres['transactid']+'","dpstxnref":"'+payres['dpstxnref']+'","cardholder":"'+payres['cardholder']+'","paysource":"Windcave WickedCOM","cardnumber":"'+payres['cardnumber']+'","cardexpiry":"'+txt2+'","transtype":"Payment","payscenario":1,"emailoption":1}';
    
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  //nz
  getRCMLocationnz(country="nz"){
    let key=this.rcmgetkey(country);
    let signature:any;
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update('{"method":"step1"}');
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request={"method":"step1"}';
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
        
    );
  }

  getRCMAge(country="au"){
    let key=this.rcmgetkey(country);
    let signature:any;
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update('{"method":"driverages"}');
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request={"method":"driverages"}';
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result['results'];
        }),
        
    );
  }
  getRCMVehicles(data){
    let key=this.rcmgetkey(data.country);
    let signature:any;
    let method='{"method":"step2","vehiclecategorytypeid":"0","pickuplocationid":'+data.pickuploc+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","pickuptime":"'+moment(data.pickuptime).format("HH:mm")+'","dropofflocationid":'+data.dropoffloc+',"dropoffdate":"'+moment(data.dropoffdate).format("DD/MM/YYYY")+'","dropofftime":"'+moment(data.dropofftime).format("HH:mm")+'","ageid":'+data.age+',"campaigncode":"'+data.voucher+'"}';
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMExtras(data){
    let key=this.rcmgetkey(data.country);
    let signature:any;
    let method='{"method":"step3","vehiclecategorytypeid":'+data.catid+',"pickuplocationid":'+data.pickuploc+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","pickuptime":"'+moment(data.pickuptime).format("HH:mm")+'","dropofflocationid":'+data.dropoffloc+',"dropoffdate":"'+moment(data.dropoffdate).format("DD/MM/YYYY")+'","dropofftime":"'+moment(data.dropofftime).format("HH:mm")+'","ageid":'+data.age+',"vehiclecategoryid":'+parseInt(data.id)+',"campaigncode":"'+data.voucher+'"}';
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  //nz
  getRCMExtrasnz(data){
    let key=this.rcmgetkey(data.country);
    let signature:any;
    let method='{"method":"step3","vehiclecategorytypeid":'+data.catid+',"pickuplocationid":'+data.pickuploc+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","pickuptime":"'+moment(data.pickuptime).format("HH:mm")+'","dropofflocationid":'+data.dropoffloc+',"dropoffdate":"'+moment(data.dropoffdate).format("DD/MM/YYYY")+'","dropofftime":"'+moment(data.dropofftime).format("HH:mm")+'","ageid":'+data.age+',"vehiclecategoryid":'+parseInt(data.id)+',"campaigncode":"'+data.voucher+'"}';
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMcalcTotal(data,mandatory="",opt=""){
    let key=this.rcmgetkey("au");
    let signature:any;
    let optmethod="";
    if(mandatory!=""){
      optmethod=',"mandatoryfees":'+mandatory
      
    }
    if(opt!=""){
      optmethod=optmethod+',"optionalfees":'+opt;
    }
    console.log(optmethod);
    let method='{"method":"calctotal","pickuplocationid":'+data.locid+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","vehiclecategoryid":'+data.carid+',"numberofdays":'+data['noofday']+',"totalrateafterdiscount":'+data.total+',"freedaysamount":'+data.freedays+',"insuranceid":'+data.insuid+',"extrakmsid":'+data.kmsid+optmethod+'}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }

  getRCMcalcTotalnz(data,mandatory="",opt=""){
    let key=this.rcmgetkey("nz");
    let signature:any;
    let optmethod="";
    if(mandatory!=""){
      optmethod=',"mandatoryfees":'+mandatory
      
    }
    if(opt!=""){
      optmethod=optmethod+',"optionalfees":'+opt;
    }
    console.log(optmethod);
    let method='{"method":"calctotal","pickuplocationid":'+data.locid+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","vehiclecategoryid":'+data.carid+',"numberofdays":'+data['noofday']+',"totalrateafterdiscount":'+data.total+',"freedaysamount":'+data.freedays+',"insuranceid":'+data.insuid+',"extrakmsid":'+data.kmsid+optmethod+'}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }

  getRCMSaveBooking(data,customer="",opt=""){
    let key=this.rcmgetkey("au");
    let signature:any;
    let optmethod="";
    //console.log("refidserv:"+sessionStorage.getItem('refid'));
    if(sessionStorage.getItem('refid')){
      optmethod=optmethod+',"referralid":'+sessionStorage.getItem('refid');
    }
    if(customer!=""){
      optmethod=optmethod+',"customer":'+customer
      
    }
    if(opt!=""){
      optmethod=optmethod+',"optionalfees":'+opt;
    }
    //console.log(optmethod);
    let method='{"method":"booking","vehiclecategorytypeid":'+data.vehiclecategorytypeid+',"pickuplocationid":'+data.pickuplocationid+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","pickuptime":"'+moment(data.pickuptime).format("HH:mm")+'","dropofflocationid":'+data.dropofflocationid+',"dropoffdate":"'+moment(data.dropoffdate).format("DD/MM/YYYY")+'","dropofftime":"'+moment(data.dropofftime).format("HH:mm")+'","ageid":'+data.ageid+',"vehiclecategoryid":'+data.vehiclecategoryid+',"bookingtype":'+data.bookingtype+',"insuranceid":'+data.insuranceid+',"extrakmsid":'+data.extrakmsid+',"transmission":'+data.transmission+',"numbertravelling":'+data.numbertravelling+',"remark":"'+data.remark+'","areaofuseid":"'+data.areaofuseid+'","flightin":"'+data.flightin+'","flightout":"'+data.flightout+'"'+optmethod+'}';
    //console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMSaveBookingnz(data,customer="",opt=""){
    let key=this.rcmgetkey("nz");
    let signature:any;
    let optmethod="";
    //console.log("refidserv:"+sessionStorage.getItem('refid'));
    if(sessionStorage.getItem('refid')){
      optmethod=optmethod+',"referralid":'+sessionStorage.getItem('refid');
    }
    if(customer!=""){
      optmethod=optmethod+',"customer":'+customer
      
    }
    if(opt!=""){
      optmethod=optmethod+',"optionalfees":'+opt;
    }
    //console.log(optmethod);
    let method='{"method":"booking","vehiclecategorytypeid":'+data.vehiclecategorytypeid+',"pickuplocationid":'+data.pickuplocationid+',"pickupdate":"'+moment(data.pickupdate).format("DD/MM/YYYY")+'","pickuptime":"'+moment(data.pickuptime).format("HH:mm")+'","dropofflocationid":'+data.dropofflocationid+',"dropoffdate":"'+moment(data.dropoffdate).format("DD/MM/YYYY")+'","dropofftime":"'+moment(data.dropofftime).format("HH:mm")+'","ageid":'+data.ageid+',"vehiclecategoryid":'+data.vehiclecategoryid+',"bookingtype":'+data.bookingtype+',"insuranceid":'+data.insuranceid+',"extrakmsid":'+data.extrakmsid+',"transmission":'+data.transmission+',"numbertravelling":'+data.numbertravelling+',"remark":"'+data.remark+'","areaofuseid":"'+data.areaofuseid+'","flightin":"'+data.flightin+'","flightout":"'+data.flightout+'"'+optmethod+'}';
    //console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMBookingInfo(resref){
    let key=this.rcmgetkey("au");
    let signature:any;
    let method='{"method":"bookinginfo","reservationref":"'+resref+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMBookingInfonz(resref){
    let key=this.rcmgetkey("nz");
    let signature:any;
    let method='{"method":"bookinginfo","reservationref":"'+resref+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMvaulturl(resref){
    let key=this.rcmgetkey("au");
    let signature:any;
    let method='{"method":"getvaulturl","reservationref":"'+resref+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getRCMvaulturlnz(resref){
    let key=this.rcmgetkey("nz");
    let signature:any;
    let method='{"method":"getvaulturl","reservationref":"'+resref+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }

  saveRCMvault(resref,data){
    let key=this.rcmgetkey("au");
    let signature:any;
    let method='{"method":"vaultentry","reservationref":"'+resref+'","data":"'+data+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  saveRCMvaultnz(resref,data){
    let key=this.rcmgetkey("nz");
    let signature:any;
    let method='{"method":"vaultentry","reservationref":"'+resref+'","data":"'+data+'"}';
    console.log(method);
    var shaObj = new jsSHA("SHA-256","TEXT");
    shaObj.setHMACKey(key.secret, "TEXT");
    shaObj.update(method);
    signature = shaObj.getHMAC("HEX");
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type','application/x-www-form-urlencoded');
    let body='signature='+signature+'&request='+method;
    return this.http
      .post(this.RCMbookingurl+key.key+'?apikey='+key.key,body,{headers: headers,})
      .pipe(
        map(result => {
          return result;
        }),
    );
  }
  getBookingSetting() {
    return this.http
      .get(`${this.AUBookapiurl}/v3/bookings/getsetting`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  getBookingSettingnz() {
    return this.http
      .get(`${this.NZBookapiurl}/v3/bookings/getsetting`)
      .pipe(
        map(result => {
          return result;
        }),
      );
  }
  getmaplist() {
    return this.http
      .get(`${this.baseUrl}/location/maplist/`)
      .pipe(
        map(result => {
          return result['results'];
        }),
      );
  }
  //
  setTitle(){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`title`) || null
    if (element==null) {
      //console.log("rel nul;",tag);
      element= this.dom.createElement('title') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('innerHTML',"test");
    return element;
  }
  setMeta(tag:string,url:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`meta[name='`+tag+`']`) || null
    if (element==null) {
      //console.log("rel nul;",tag);
      element= this.dom.createElement('meta') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('name',tag)
    element.setAttribute('content',url)
  }
  setLinkRel(url:string,tag:string){
    const head = this.dom.getElementsByTagName('head')[0];
    var element: HTMLLinkElement= this.dom.querySelector(`link[rel='`+tag+`']`) || null
    if (element==null) {
      //console.log("rel nul;",tag);
      element= this.dom.createElement('link') as HTMLLinkElement;
      head.appendChild(element);
    }
    element.setAttribute('rel',tag)
    element.setAttribute('href',url)
  }
}
